// Vista previa de un mensaje tal y como se verá en WhatsApp: burbuja verde
// sobre el fondo del chat, con el formato *negrita* y _cursiva_ aplicado.
import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DoneAllIcon from "@mui/icons-material/DoneAll";

// Convierte *texto* en negrita y _texto_ en cursiva, como hace WhatsApp.
function formatearLinea(linea) {
  const partes = linea.split(/(\*[^*\n]+\*|_[^_\n]+_)/g).filter(Boolean);
  return partes.map((parte, i) => {
    const key = `${i}-${parte}`;
    if (parte.length > 2 && parte.startsWith("*") && parte.endsWith("*")) {
      return (
        <Box component="strong" key={key} sx={{ fontWeight: 700 }}>
          {parte.slice(1, -1)}
        </Box>
      );
    }
    if (parte.length > 2 && parte.startsWith("_") && parte.endsWith("_")) {
      return (
        <Box component="em" key={key} sx={{ color: "#54656F" }}>
          {parte.slice(1, -1)}
        </Box>
      );
    }
    return <React.Fragment key={key}>{parte}</React.Fragment>;
  });
}

export default function MensajeWhatsApp({ texto, hora, sx }) {
  const lineas = texto.split("\n");
  return (
    <Box
      sx={{
        bgcolor: "#EFEAE2",
        backgroundImage:
          "radial-gradient(rgba(84,101,111,0.07) 1px, transparent 1px), radial-gradient(rgba(84,101,111,0.05) 1px, transparent 1px)",
        backgroundSize: "18px 18px, 18px 18px",
        backgroundPosition: "0 0, 9px 9px",
        borderRadius: "16px",
        p: { xs: 1.5, sm: 2 },
        ...sx,
      }}
    >
      <Box
        sx={{
          position: "relative",
          bgcolor: "#D9FDD3",
          borderRadius: "12px 4px 12px 12px",
          px: 1.5,
          pt: 1.25,
          pb: 0.75,
          ml: "auto",
          maxWidth: 360,
          boxShadow: "0 1px 0.5px rgba(11,20,26,0.13)",
        }}
      >
        <Typography
          component="div"
          sx={{ fontSize: "0.86rem", lineHeight: 1.5, color: "#111B21", fontFamily: "inherit" }}
        >
          {lineas.map((linea, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Box key={i} sx={{ minHeight: "0.75em", whiteSpace: "pre-wrap" }}>
              {linea ? formatearLinea(linea) : null}
            </Box>
          ))}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 0.5,
            mt: 0.25,
            color: "#667781",
            fontSize: "0.68rem",
          }}
        >
          {hora}
          <DoneAllIcon sx={{ fontSize: 16, color: "#53BDEB" }} />
        </Box>
      </Box>
    </Box>
  );
}

MensajeWhatsApp.propTypes = {
  texto: PropTypes.string.isRequired,
  hora: PropTypes.string,
  sx: PropTypes.object,
};

MensajeWhatsApp.defaultProps = {
  hora: "",
  sx: {},
};
